// Terms.jsx
import React from "react";
import css from "./Terms.module.css";
import { Link } from "react-router-dom";
import illustration from "../../assets/hero.png";

export default function Terms() {
  return (
    <main className={css.page}>
      <header className={css.hero}>
        <div className={css.heroText}>
          <h1>Termos de Uso</h1>
          <p className={css.lead}>
            Estes Termos regulam o uso da plataforma
            <strong> ProcessBasedPersonality</strong>, dedicada a atividades
            educacionais, grupos de discussão e cursos voltados a profissionais
            da saúde mental.
          </p>
        </div>

        <figure className={css.heroImageWrap} aria-hidden>
          <img src={illustration} alt="" className={css.heroImage} />
        </figure>
      </header>

      <section className={css.container}>
        <article className={css.card}>
          <h2>1. Quem somos</h2>
          <p>
            ProcessBasedPersonality é uma plataforma educacional mantida pelo
            Instituto Bhava LTDA — CNPJ 63.304.502/0001-26, voltada à formação
            continuada e à discussão teórica em terapias contextuais, ACT, RFT e
            modelos baseados em processos.
          </p>
        </article>

        <article className={css.card}>
          <h2>2. Aceitação dos Termos</h2>
          <p>
            Ao acessar ou utilizar a plataforma, você declara que leu,
            compreendeu e concorda integralmente com estes Termos de Uso. Caso
            não concorde, não utilize os serviços.
          </p>
        </article>

        <article className={css.card}>
          <h2>3. Serviços oferecidos</h2>
          <p>
            A plataforma oferece grupos de discussão de casos clínicos em
            formato educacional, cursos online (gravados e ao vivo), eventos e
            conteúdos formativos.
          </p>
          <p>
            A plataforma <strong>não oferece</strong> psicoterapia, atendimento
            clínico, supervisão formal ou qualquer serviço assistencial em saúde
            mental.
          </p>
        </article>

        <article className={css.card}>
          <h2>4. Natureza educacional e responsabilidade profissional</h2>
          <p>
            Os grupos de discussão e cursos possuem caráter exclusivamente
            educacional. As discussões de casos devem ser realizadas de forma
            anonimizada e conceitual.
          </p>
          <p>
            A responsabilidade ética, técnica e legal pelo atendimento clínico
            permanece integralmente com o profissional participante.
          </p>
        </article>

        <article className={css.card}>
          <h2>5. Contas de usuário</h2>
          <p>
            O usuário é responsável por manter a confidencialidade de suas
            credenciais de acesso e por todas as atividades realizadas em sua
            conta. Qualquer uso não autorizado deve ser comunicado
            imediatamente.
          </p>
        </article>

        <article className={css.card}>
          <h2>6. Pagamentos e cursos pagos</h2>
          <p>
            Cursos pagos, quando disponíveis, terão suas condições descritas nas
            respectivas páginas de venda. Pagamentos são processados por
            provedores terceiros. Políticas de cancelamento e reembolso seguem
            as regras específicas de cada produto.
          </p>
        </article>

        <article className={css.card}>
          <h2>7. Propriedade intelectual</h2>
          <p>
            Todo o conteúdo original disponibilizado na plataforma é protegido
            por direitos autorais e de propriedade intelectual. É vedada a
            reprodução, distribuição ou comercialização sem autorização
            expressa.
          </p>
        </article>

        <article className={css.card}>
          <h2>8. Limitação de responsabilidade</h2>
          <p>
            A plataforma fornece conteúdos educacionais e espaços de discussão.
            Não se responsabiliza por decisões clínicas tomadas pelos usuários a
            partir das informações discutidas.
          </p>
        </article>

        <article className={css.card}>
          <h2>9. Privacidade</h2>
          <p>
            O tratamento de dados pessoais segue a nossa{" "}
            <Link to="/privacy">Política de Privacidade</Link>, que integra
            estes Termos de Uso.
          </p>
        </article>

        <article className={css.card}>
          <h2>10. Alterações dos Termos</h2>
          <p>
            Estes Termos podem ser atualizados a qualquer momento. Recomendamos
            que o usuário revise periodicamente este documento.
          </p>
        </article>

        <article className={css.cardSmall}>
          <h3>Contato</h3>
          <p>
            ProcessBasedPersonality
            <br />
            Instituto Bhava LTDA — CNPJ 63.304.502/0001-26
            <br />
            E-mail: <strong>institutobhava@gmail.com</strong>
          </p>
        </article>
      </section>
    </main>
  );
}
